import { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  Avatar,
  FormControl,
  Select,
  MenuItem, Switch
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
//Icons
import SearchIcon from "@mui/icons-material/Search";
//Srcs
import "../Style/pagestyle.scss";
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import { GET_SUPPLIER_PAGINATION, UPDATE_SUPPLIER_IS_USE } from "../Schema/Supplier";
import EmptyData from "../Components/Include/EmptyData";
import SupplierAction from "../Components/Supplier/SupplierAction";
import CreateSupplier from "../Components/Supplier/CreateSupplier";
import CreateIcon from "../Assets/create-icon.svg";
import { AuthContext } from "../Context/AuthContext";

export default function Supplier() {
  const [loading, setLoading] = useState(true);
  const { setAlert } = useContext(AuthContext);


  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [status, setStatus] = useState("All");

  const { refetch } = useQuery(GET_SUPPLIER_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      keyword: keyword,
      isUse: status === "All" ? null : status,
    },
    onCompleted: ({ getSupplierPagination }) => {
      setTableData(getSupplierPagination?.data);
      setPaginationData(getSupplierPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLoading(true);
    setLimit(e.target.value);
    setPage(1);
  };

  const [updateSupplierIsUse] = useMutation(UPDATE_SUPPLIER_IS_USE, {
    onCompleted: ({ updateSupplierIsUse }) => {
      if (updateSupplierIsUse?.status) {
        setAlert(true, "success", updateSupplierIsUse?.message);
      } else {
        setAlert(true, "error", updateSupplierIsUse?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateStatus = (id, status) => {
    updateSupplierIsUse({
      variables: {
        id: id,
        isUse: status
      }
    })
  }

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">ការកំណត់</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">អ្នកផ្គត់ផ្គង់</Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្វែងរក</Typography>
            <TextField
              placeholder="ស្វែងរកឈ្មោះអ្នកប្រើប្រាស់"
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្ថានភាព</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select value={status} onChange={(e) => setStatus(e.target.value)}>
                <MenuItem value="All">
                  ទាំងអស់
                </MenuItem>
                <MenuItem value={true}>
                  ប្រើប្រាស់
                </MenuItem>
                <MenuItem value={false}>មិនប្រើប្រាស់</MenuItem>

              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={6} xl={7.2}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
            <CreateSupplier
              open={open}
              handleClose={handleClose}
              setRefetch={refetch}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start" width="2%">
                ល.រ
              </TableCell>
              <TableCell className="header-title" width="10%">
                ឈ្មោះអ្នកផ្គត់ផ្គង់
              </TableCell>
              <TableCell className="header-title" align="center" width="9%">
                លេខទូរស័ព្ទ
              </TableCell>
              <TableCell className="header-title" width="10%">
                អ៊ីម៉ែល
              </TableCell>
              <TableCell className="header-title" width="10%">
                អាស័យដ្ឋាន
              </TableCell>
              <TableCell className="header-title" width="5%" align="center">
                Status
              </TableCell>
              <TableCell className="header-title-end" width="18%"></TableCell>
            </TableHead>


            {loading ? (
              <LoadingPage colSpan={7} />
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <EmptyData colSpan={7} />
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className="body-row"
                          key={index}
                        >
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}

                          </TableCell>

                          <TableCell className="body-cell" align="center">
                            <Stack direction="row" spacing={1}>
                              <Avatar
                                sx={{ width: 40, height: 40 }}
                                // alt={row?.lastName}
                                src={row?.imageSrc}
                              />
                              <Stack direction="column" justifyContent="center">
                                <Typography
                                  className="member-name"
                                  fontWeight="bold"
                                >
                                  {row?.name}

                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                          <TableCell className="body-cell" align="center">
                            {row?.tel}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.email}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.address}
                          </TableCell>
                          <TableCell className="body-cell" align="center">
                            <Box>
                              <Switch
                                checked={row?.isUse}
                                onChange={() => handleUpdateStatus(row?._id, !row?.isUse)}
                              />
                            </Box>
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            <SupplierAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}

        />
      </Box>
    </div>
  );
}
